import { render, staticRenderFns } from "./RespSafeRegConfirmation.vue?vue&type=template&id=6e9699e3"
import script from "./RespSafeRegConfirmation.vue?vue&type=script&lang=js"
export * from "./RespSafeRegConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports